module.exports = __webpack_public_path__ + "shared-facebook-white.svg?4aa891f542016b5e161322b97e5f299b";